import {
  AVG_MINUTES_PER_CHARACTER,
  CHARACTERS_PER_MINUTE,
} from '@src/constants/packageComparison';

const calculateCredits = (credits, rate) => Math.ceil(credits / rate);

const calculateMinutes = (credits, rate = 1) => {
  const creditsPerCycle = calculateCredits(credits, rate);
  const minutes =
    creditsPerCycle / AVG_MINUTES_PER_CHARACTER / CHARACTERS_PER_MINUTE;
  return Math.ceil(minutes * 10) / 10;
};

export { calculateCredits, calculateMinutes };
